import React from "react";

const ContextBridge = ({ children, contexts, render }) => {
  const nestContexts = (index, accumulatedChildren) => {
    if (index >= contexts.length) {
      return render(accumulatedChildren);
    }

    const { Context } = contexts[index];

    return (
      <Context.Consumer>
        {(value) =>
          nestContexts(
            index + 1,
            <Context.Provider value={value}>
              {accumulatedChildren}
            </Context.Provider>
          )
        }
      </Context.Consumer>
    );
  };

  return nestContexts(0, children);
};

export default ContextBridge;
